// extracted by mini-css-extract-plugin
module.exports = {"container":"_1R5LDX5iO7RRCXtg7b1x","input":"_3dgYMl0RWVc36AWq1WGi","team1-name":"_2s9XVGUTNcrXZlx5JRR6"};